import { types, Instance } from 'mobx-state-tree';
import { ExplorerHistoryModel } from './models/explorerHistory.model';
import { withLDAPStore } from 'domain/ldap';
import { arrangeIntoTree, TreeItem, PathItem, NodeData, findNodeById } from 'utils';

const { model, array, string, enumeration } = types;

export const BaseTreeExplorerStore = model('BaseTreeExplorerStore', {
  selectedBase: string,
  selectedId: string,
  expandedIds: array(string),
  currentBaseNodeId: string,
  currentHistory: enumeration('currentHistory', ['navigation', 'input']),
  inputHistory: ExplorerHistoryModel,
  navigationHistory: ExplorerHistoryModel,
  internalBase: string,
  selectedinternalBaseGroup: false,
})
  .extend(withLDAPStore)
  .views((self) => ({
    get baseTree(): TreeItem {
      const parsedBasePaths: PathItem[] = [];
      parsedBasePaths.push({ id: 'all', base: 'all', parsedBase: ['all'] });
      self.ldapStore.departments.forEach(({ dn: id, base }) => {
        const parsedBase = base !== '/' ? ['all', '/', ...base.replace(/^\//, '').split('/')] : ['all', '/'];

        parsedBasePaths.push({ id, base, parsedBase });
      });

      return arrangeIntoTree(parsedBasePaths.sort((a, b) => a.parsedBase.length - b.parsedBase.length));
    },

    get selected(): string {
      return self.currentHistory === 'navigation' ? self.navigationHistory.baseNodeId : self.inputHistory.baseNodeId;
    },
    get getSelectedGroup(): boolean {
      return false;
    },
    get getInternalFilterBaseLink() {
      return self.internalBase;
    },
    get expanded(): string[] {
      const expanded =
        self.currentHistory === 'navigation'
          ? self.navigationHistory.expandedNodeIds
          : self.inputHistory.expandedNodeIds;

      return expanded.length ? expanded : [];
    },
    get getInternalBaseLinkGroup() {
      return self.selectedinternalBaseGroup;
    },
  }))
  .actions((self) => ({
    putNodeDataToHistory(nodeData: NodeData | null): void {
      self.inputHistory.base = nodeData?.base || '/';
      self.inputHistory.baseNodeId = nodeData?.id || '';
      self.inputHistory.parentNodeId = nodeData?.parentId || '';
      if (self.currentHistory === 'navigation') {
        self.ldapStore.setCurrentBase(nodeData?.base || '/');
        self.navigationHistory.base = nodeData?.base || '/';
        self.navigationHistory.baseNodeId = nodeData?.id || '';
        self.navigationHistory.parentNodeId = nodeData?.parentId || '';
      }
    },
  }))
  .actions((self) => ({
    setInternalFilterBaseLink(base: string) {
      self.internalBase = base;
    },
    setBase(newBase: string) {
      self.navigationHistory.base = newBase;
    },
    setCurrentHistory(historyType: 'navigation' | 'input'): void {
      self.currentHistory = historyType;
    },
    selectedInternalFilterBaseLink(value: boolean) {
      self.selectedinternalBaseGroup = value;
    },

    setSelected(nodeId: string): void {
      const nodeData = findNodeById(self.baseTree, nodeId);
      self.putNodeDataToHistory(nodeData);
    },

    setExpanded(expandedNodeIds: string[]): void {
      self.inputHistory.expandedNodeIds.replace(expandedNodeIds);

      if (self.currentHistory === 'navigation') {
        self.navigationHistory.expandedNodeIds.replace(expandedNodeIds);
      }
    },

    navigateToRoot(): void {
      self.ldapStore.setCurrentBase('/');
      self.inputHistory = { ...self.inputHistory, base: '/', baseNodeId: self.baseTree.id, parentNodeId: '' };
      self.navigationHistory = { ...self.navigationHistory, base: '/', baseNodeId: self.baseTree.id, parentNodeId: '' };
    },

    navigateToPreviosLevel(): void {
      const nodeData = findNodeById(self.baseTree, self.navigationHistory.parentNodeId);
      self.putNodeDataToHistory(nodeData);
    },
  }));

export type IBaseTreeExplorerStore = Instance<typeof BaseTreeExplorerStore>;
